import React                  from 'react';
import connect                from 'react-redux/es/connect/connect';
import ToggleList             from './ToggleList';
import { Error, Success }     from '../shared/toast';
import * as _ from 'lodash';

import {
    clearErrors,
    clearSave,
    loadCapabilities,
    restFlags,
    saveCapabilities,
    setFlag
}                             from '../../store/actions/capabilities';
class CapabilitiesView extends React.PureComponent {
    componentDidMount() {
        this.props.onLoad();
    }

    render() {
        const { isLoading } = this.props;
        let groupedCategories = {};

        if(!isLoading) {
            groupedCategories = _.groupBy(this.props.capabilities, capability => capability.Category || "General");
            console.warn(groupedCategories);
        }
        return (
                <section className="pc-container">
                    {this.props.isLoading ?

                        <div className="pc-loader pc-loader--large pc-loader--grey spinner--rotate"/> :

                        <React.Fragment>
                            {this.props.currentFlags && this.props.capabilities &&

                             <React.Fragment>
                                 {Object.keys(groupedCategories).map(category =>
                                     <ToggleList category={category}
                                                 key={category}
                                                 capabilities={groupedCategories[category]}
                                                 flags={this.props.currentFlags}
                                                 onChange={this.props.onFlagChange} />
                                 )}


                                <footer className="pc-btn-group pc-btn-group--right-align">
                                    <button className="pc-btn pc-btn--secondary pc-btn--medium"
                                            onClick={this.props.onCancelFlags}
                                            disabled={!this.props.hasChanges}>
                                        Cancel
                                    </button>
                                    <button
                                        className="pc-btn pc-btn--primary-reversed pc-btn--medium"
                                        disabled={!this.props.hasChanges}
                                        onClick={this.props.onSave}>
                                        Save changes
                                    </button>
                                </footer>
                             </React.Fragment>
                                 }
                        </React.Fragment>
                    }
                    <Error visible={this.props.loadError} onClose={this.props.onClearErrors}>Couldn't load capabilities for this restaurant.</Error>
                    <Error visible={this.props.saveError} onClose={this.props.onClearErrors}>Couldn't save changes for this restaurant.</Error>
                    <Success visible={this.props.saveSuccess} onClose={this.props.onSaveDismiss}>Changes saved.</Success>
                </section>
        )
    }
}

export default connect(
    state => ({
        ...state.capabilities
    }),
    // Actions
    {
        onLoad: loadCapabilities,
        onFlagChange: setFlag,
        onCancelFlags: restFlags,
        onSave: saveCapabilities,
        onClearErrors: clearErrors,
        onSaveDismiss: clearSave
    }
)(CapabilitiesView);



// WEBPACK FOOTER //
// /src/components/RestaurantView/CapabilitiesView.js